import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
            <i className={`${icon} text-xl`}></i>
          </span>
        )}
        <div>
          <h2 className="text-lg font-bold text-foreground-900 md:text-xl">{title}</h2>
          {subtitle && <p className="mt-0.5 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-base"></i>
        </Link>
      )}
    </div>
  );
}